// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faUser, faUserCheck } from '@fortawesome/free-solid-svg-icons'

import {
  Spinner,
  SvgIcon,
  DetailPageHeader,
  // ToolbarIdentityCases,
  // CreateCaseModal,
  EmployeePageNavigation,
  EmployeeDetail,
  Warning
} from '../../components'

import {
  isBase64,
  // decodeBase64,
  readablePhoneNumber,
  getNodeTypeFromBase64Id,
  // getContentTypeFromNodeType
} from '../../utils'

// const createCaseModalRef = React.createRef()
// const casesCountAndCreateRef = React.createRef()

const initialiseFromUrl = (props) => {
  if (props.location.pathname.length > props.match.url.length) {
    let lastPathSegment = props.location.pathname.split('/').pop()
    let detail = lastPathSegment.split('?')[0]  // drops query string part

    if (isBase64(detail)) {
      switch(getNodeTypeFromBase64Id(detail)) {
        case 'PayrollCycleNode':
          return { detail: 'payrollcycles', detailObjectId: detail }

        case 'RequestRunNode':
          return { detail: 'requests', detailObjectId: detail }

        case 'WhatsappMessageNode':
          return { detail: 'whatsapp', detailObjectId: detail }

        default:
          return { detail, detailObjectId: null }
      }
    } else {
      return { detail, detailObjectId: null }
    }
  } else {
    return { detail: 'general', detailObjectId: null }
  }
}


class Employee extends React.PureComponent {
  static propTypes = {
    identityId: PropTypes.string
  }

  static getDerivedStateFromProps(props, state) {
    return initialiseFromUrl(props)
  }

  state = {}

  // componentDidMount() {
  //   document.addEventListener('mousedown', this.handleClickOutside)
  // }
  //
  // componentWillUnmount() {
  //   document.removeEventListener('mousedown', this.handleClickOutside)
  // }
  //
  // handleClickOutside = (e) => {
  //   if (createCaseModalRef.current && !createCaseModalRef.current.contains(e.target)) {
  //     // click is outside, close modal
  //     this.setState({ showCreateCaseModal: false })
  //   }
  // }

  getIdentityTypesArray = (identity) => {
    let identityTypes = []

    if (identity.isClient) {
      identityTypes.push('client')
    }
    if (identity.isEmployer) {
      identityTypes.push('employer')
    }
    if (identity.isContact) {
      identityTypes.push('contact')
    }

    return identityTypes
  }

  getIDNumberAndCellphone = (identity) => {
    if (identity.isClient) {
      return [
        {
          title: 'ID number',
          value: identity.identityValue
        },
        {
          title: 'Cellphone',
          value: identity.defaultCellphoneNumber.edges.length > 0
            ? readablePhoneNumber(identity.defaultCellphoneNumber.edges[0].node.addressValue)
            : '-'
        }
      ]
    } else if (identity.isContact) {
      let preferredAddressType = identity.defaultAddressType

      let hasDefaultActiveCellphoneNumber = identity.defaultCellphoneNumber.edges.length > 0   // or instead use identity.msisdnDefault
      let hasDefaultActiveEmailAddress = identity.defaultEmailAddress.edges.length > 0

      let defaultActiveCellphoneNumber = hasDefaultActiveCellphoneNumber
        ? readablePhoneNumber(identity.defaultCellphoneNumber.edges[0].node.addressValue)
        : '-'
      let defaultActiveEmailAddress = hasDefaultActiveEmailAddress
        ? identity.defaultEmailAddress.edges[0].node.addressValue
        : '-'

      let contactStatusInfo =  [
        {
          title: 'ID number',
          value: identity.identityValue
            ? identity.identityValue
            : '-'
        }
      ]

      if (preferredAddressType === 'MSISDN') {
        contactStatusInfo.push({
          title: hasDefaultActiveCellphoneNumber
            ? 'Cellphone'
            : hasDefaultActiveEmailAddress
              ? 'Email'
              : null,
          value: hasDefaultActiveCellphoneNumber  // or instead use identity.msisdnDefault
            ? readablePhoneNumber(identity.defaultCellphoneNumber.edges[0].node.addressValue)
            : defaultActiveEmailAddress
        })
      } else if (preferredAddressType === 'EMAIL') {
        contactStatusInfo.push({
          title: hasDefaultActiveEmailAddress
            ? 'Email'
            : hasDefaultActiveCellphoneNumber
              ? 'Cellphone'
              : null,
          value: defaultActiveEmailAddress
            ? identity.defaultEmailAddress.edges[0].node.addressValue
            : defaultActiveCellphoneNumber
        })
      }

      return contactStatusInfo
    } else {
      return []
    }
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' />
    }

    if (this.props.data.error) {
      return <h1>Oh dear! We have an issue</h1>
    }

    let identity = this.props.data.identity
    let identityTypes = identity ? this.getIdentityTypesArray(identity) : null

    if (identity === null) {
      return <Warning className='slds-p-around_large'>No identity found!</Warning>
    }

    return (
      <div className='slds-grid slds-grid_vertical' style={{ height: '90vh', overflow: 'hidden' }}>
        <div>
          <DetailPageHeader
            title={identity.fullName}
            icon={
              <Icon
                icon={identity.verified ? faUserCheck : faUser}
                size='3x'
                className={identity.verified ? 'identity-verified' : 'slds-text-color_weak'}
                title={identity.verified ? 'Verified identity' : 'Unverified identity'}
              />
            }
            statuses={this.getIDNumberAndCellphone(identity)}
          />
          <EmployeePageNavigation
            // employerId={identity.client.division.employer.id}
            identityId={identity.id}
            identityTypes={identityTypes}
            onTabClick={(tabName, objectId) => {
              // clear url search parameters if any
              if (this.props.location.search) {
                this.props.history.replace({ search: null })
              }
              this.setState({ detail: tabName, detailObjectId: objectId })
            }}
            initialTab={this.state.detailObjectId || this.state.detail}
          />
        </div>
        <div className='stage-main slds-scrollable_y' role='main'>
          {this.state.detail
            ? <EmployeeDetail
                identityId={identity.id}
                detail={this.state.detail}
                objectId={this.state.detailObjectId}
                key={this.state.caseAdditionTimeStamp}
                // whenever a case is added, IdentityDetail will be rerendered to ensure that the identity case listing is updated
              />
            : null
          }
        </div>
        {this.state.showCreateCaseModal && this.showCreateCaseModal(identity.id)}
      </div>
    )
  }
}

const getIdentity = gql`
  query($id: ID!) {
    identity(id: $id) {
      id
      defaultAddressType
      fullName
      identityValue
      isClient
      isContact
      isEmployee
      isEmployer
      summary
      verified
      defaultCellphoneNumber: addresses(addressType: "msisdn", default: true, inactive: false) {
        edges {
          node {
            id
            addressValue
          }
        }
      }
      defaultEmailAddress: addresses(addressType: "email", default: true, inactive: false) {
        edges {
          node {
            id
            addressValue
          }
        }
      }
      client {
        id
        summary
        division {
          id
          employer {
            id
          }
        }
      }
      employer {
        id
        friendlyName
        employergroup {
          id
          friendlyName
        }
      }
    }
  }
`

const withData =
  graphql(getIdentity, {
    options: (ownProps) => ({
      variables: {
        id: ownProps.match.params.identityId
      }
    })
  })

export default compose(
  withData,
  withRouter
)(Employee)



// WEBPACK FOOTER //
// ./src/containers/messageplus/EmployeeDetail.js